let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lPk9Z")).then(() => parcelRequire('h77Xn'));